<template>
  <theme-four/>
</template>

<script>
import ThemeFour from '../../../components/faq/general-theme-four'
export default {
  name: 'GeneralThemeFourView',
  components: {
    ThemeFour
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/faq/general-theme-four.view.vue